<script lang="ts">
	import { SnapshotModifier } from "@calibration/snapshot-modifier"
	import type { SnapshotData } from "../../types"
	import { type Snapshot, DataHandlerSnapshot } from "luxedo-data"

	interface Props {
		snapshots: SnapshotData[]
		onComplete: (snap: SnapshotData) => void
		cancel: () => void
	}

	let { snapshots, onComplete, cancel }: Props = $props()

	let snapshotsAsLuxedoTypes = $derived(snapshots.map((s) => DataHandlerSnapshot.get(Number(s.id))))
	function onModifyComplete(snap: Snapshot) {
		onComplete({
			id: snap.id.toString(),
			edited: snap.edited,
			src: snap.src,
		})
	}
</script>

<div class="modify-snaps">
	<SnapshotModifier snapshots={snapshotsAsLuxedoTypes} onComplete={onModifyComplete} {cancel} />
</div>

<style>
	.modify-snaps {
		height: 100%;
	}

	.modify-snaps :global(.scrollable-snapshots) {
		padding: 1rem 0.5rem 1rem 1rem;
	}
</style>
